import React from 'react';
import { flex } from '@fabric-ui/theme';
import { Box } from '@mui/material';

export const ProjectionIcon = ({ icon, backgroundColor, color }: { icon: React.ReactNode; backgroundColor: string; color: string }) => (
  <Box
    sx={{
      ...flex.center,
      svg: {
        backgroundColor,
        color: color ?? 'var(--color-content-inverted-base-primary)',
        padding: '6px',
        borderRadius: '12px',
        border: `1px solid ${color ? 'var(--color-border-base-secondary)' : 'transparent'}`,
        '.MuiInputBase-root.MuiOutlinedInput-root &, &': {
          height: '24px',
          width: '24px',
        },
      },
    }}>
    {icon}
  </Box>
);
